module.exports = __webpack_public_path__ + "static/media/SD-Azul.8c288ca2.png";